import { SCAN_RESULT_STATUS } from "./scan-result-status"

const SCAN_STATUS = {
    NOT_SCANNED: 'NOT_SCANNED',
    ...SCAN_RESULT_STATUS
}

const SCAN_STATUS_ORDER = {
    [SCAN_STATUS.NOT_SCANNED]: 1,
    [SCAN_STATUS.ASSET_FOUND_BUT_MOVED]: 2,
    [SCAN_STATUS.NEW_TAG]: 3,
    [SCAN_STATUS.ASSET_FOUND]: 4,
}

const SCAN_STATUS_LETTER = {
    [SCAN_STATUS.NOT_SCANNED]: 'Mi',
    [SCAN_STATUS.ASSET_FOUND_BUT_MOVED]: 'Mo',
    [SCAN_STATUS.NEW_TAG]: 'N',
    [SCAN_STATUS.ASSET_FOUND]: 'F',
}

const COLORS = {
    [SCAN_STATUS.ASSET_FOUND_BUT_MOVED]: '#993399',
    [SCAN_STATUS.ASSET_FOUND]: '#459845',
    [SCAN_STATUS.NEW_TAG]: '#ee9400',
    [SCAN_STATUS.NOT_SCANNED]: '#e8194a'
}

export {
    SCAN_STATUS,
    SCAN_STATUS_ORDER,
    SCAN_STATUS_LETTER,
    COLORS
}